/**
 * Shared compile-time constants. No env, no runtime config.
 */
/** Vendors that are real-implementation in MVP (visible enabled in onboarding). */
export const MVP_ACTIVE_VENDORS = ['deye'];
/** Cookie name for Lucia session — kept in sync between API and (rare) web reads. */
export const SESSION_COOKIE_NAME = 'session';
/** Web page of the password-reset link: `${PUBLIC_URL}${PASSWORD_RESET_PATH}?token=…`. */
export const PASSWORD_RESET_PATH = '/reset-password';
/** A password-reset link works once and for this long. */
export const PASSWORD_RESET_TTL_MS = 60 * 60 * 1000;
//# sourceMappingURL=constants.js.map